module.exports = __webpack_public_path__ + "5e02677beaf678a8cbe0333182d9d0f6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-112@2x.png
// module id = 496
// module chunks = 0